import React, { useState } from 'react';
import { supabase } from '../../config/supabaseClient';

const VerificationMessage = ({ email, onBack }) => {
  const [resendStatus, setResendStatus] = useState('');
  const [isResending, setIsResending] = useState(false);

  const handleResendVerification = async () => {
    try {
      setIsResending(true);
      setResendStatus('');
      
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: email,
      });

      if (error) throw error;
      
      setResendStatus('Verification email sent! Please check your inbox.');
    } catch (error) {
      setResendStatus(`Error: ${error.message}`);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="text-center">
      <div className="mb-6">
        <h3 className="text-2xl font-bold text-textDark mb-4">
          Check Your Email
        </h3>
        <p className="text-gray-600 mb-2">
          We've sent a verification link to:
        </p>
        <p className="font-medium text-primary mb-4">
          {email}
        </p>
        <p className="text-gray-600">
          Please click the link in the email to verify your account.
        </p>
      </div>

      <div className="space-y-4">
        {resendStatus && (
          <p className={`text-sm ${resendStatus.startsWith('Error') ? 'text-red-600' : 'text-green-600'}`}>
            {resendStatus}
          </p>
        )}
        
        <button
          onClick={handleResendVerification}
          disabled={isResending}
          className="w-full px-4 py-3 text-white bg-primary rounded-lg hover:bg-primaryDark 
                   disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isResending ? 'Sending...' : 'Resend Verification Email'}
        </button>

        <button
          onClick={onBack}
          className="w-full px-4 py-3 text-primary bg-white border border-primary 
                   rounded-lg hover:bg-gray-50 transition-colors"
        >
          Back to Sign In
        </button>
      </div>
    </div>
  );
};

export default VerificationMessage; 